import React, {useState} from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../../components/Modal";
import CustomButton from "../../../components/CustomButton";
import RadioButton from "../../../components/RadioButton";
import {VisionStatementGoal} from "../interfaces";


interface Props {
  save: Function;
  close: () => void;
  t: Function;
  lang: string;
  goal: VisionStatementGoal
}

const UpdateGoalStatus = (props: Props) => {
  const [development, setDevelopment] = useState(0);
  const [engagement, setEngagement] = useState(0);

  return (
    <Modal isOpen={true} onClose={() => props.close()}>
      <ModalHeader onClose={props.close}>
        {props.t("update-progress")}
      </ModalHeader>
      <ModalBody>

        <div className="mt-2 text-gray-300">
          {
            props.lang === "sv" ? "Ta en stund att reflektera över ditt delmål." :
              "Take moment to reflect on your Sub-goal."
          }
        </div>

        <div className="mt-4 text-gray-300">
          {
            props.lang === "sv" ? "Känner du att du har utvecklats på något sätt, till exempel genom nya insikter, färdigheter eller beteenden?" :
              "Have you noticed any personal development while working on it — such as new insights, skills, or behaviours?"
          }
        </div>

        <div className="mt-3">
          <RadioButton name="development1" label={props.lang === "sv" ? "Ja, mycket" : "Yes, significant"}
                       id="development1" value="1" checked={development === 1} onChange={() => setDevelopment(1)}/>
        </div>

        <div className="mt-3">
          <RadioButton name="development2" label={props.lang === "sv" ? "Ja, litegrann" : "Yes, to some extent"}
                       id="development2" value="2" checked={development === 2} onChange={() => setDevelopment(2)}/>
        </div>
        <div className="mt-3">
          <RadioButton name="development3" label={props.lang === "sv" ? "Nä, inte än" : "Not really"}
                       id="development3" value="3" checked={development === 3} onChange={() => setDevelopment(3)}/>
        </div>

        <div className="mt-4 text-gray-300">
          {
            props.lang === "sv" ? "Hur skulle du beskriva ditt engagemang för målbilden?" :
              "How would you describe your level of effort during this process?"
          }
        </div>

        <div className="mt-3">
          <RadioButton name="engagement1" label={props.lang === "sv" ? "Väldigt engagerad" : "Highly engaged"}
                       id="engagement1" value="1" checked={engagement === 1} onChange={() => setEngagement(1)}/>
        </div>

        <div className="mt-3">
          <RadioButton name="engagement2" label={props.lang === "sv" ? "Balanserat" : "Generally engaged"}
                       id="engagement2" value="2" checked={engagement === 2} onChange={() => setEngagement(2)}/>
        </div>
        <div className="mt-3">
          <RadioButton name="engagement3"
                       label={props.lang === "sv" ? "Mindre engagerad än jag tänkt" : "Less engaged than intended"}
                       id="engagement3" value="3" checked={engagement === 3} onChange={() => setEngagement(3)}/>
        </div>

      </ModalBody>
      <ModalFooter>
        
            <CustomButton disabled={development === 0 || engagement === 0}
                          onClick={() => props.save(development, engagement)}
                          buttonType="blueBase">
              {props.t("mark-as-complete")}
            </CustomButton>
      </ModalFooter>
    </Modal>
  )

}

export default UpdateGoalStatus;